import { FormField } from "@/components/FormField";
import { LIMITS } from "@/features/identity/validation";

export function IdentitySection({ form }) {
  const { values, errors, onChange } = form;
  return (
    <div className="grid gap-6">
      <FormField id="identity-full-name" name="full_name" label="Full name" autoComplete="name" maxLength={LIMITS.name} testId="identity-full-name-input" value={values.full_name} onChange={onChange} error={errors.full_name} />
      <FormField id="identity-title" name="professional_title" label="Professional title" placeholder="e.g. Head of Partnerships" autoComplete="organization-title" maxLength={LIMITS.title} testId="identity-title-input" value={values.professional_title} onChange={onChange} error={errors.professional_title} />
      <FormField id="identity-company" name="company_name" label="Company" optional autoComplete="organization" maxLength={LIMITS.company} hint="Independent? You can leave this blank." testId="identity-company-input" value={values.company_name} onChange={onChange} error={errors.company_name} />
    </div>
  );
}
